import voiceGif from "../../asset/Home/circleFeature.gif";
import waveform from "../../asset/Home/waveForm.svg";
import languagesBg from "../../asset/Home/languages.svg";
import latencyCard from "../../asset/Home/200ms.svg";
import { motion } from "framer-motion";
import playAI from "../../asset/Home/playAI.svg";
import { useEffect,useRef, useState } from "react";
import featureAudio from "../../asset/Home/en_02.wav"
function CoreFeatures() {
  const languageSteps = [
    "1",
    "5",
    "10",
    "16",
    "21",
    "27",
    "32",
    "38",
    "47",
    "50+",
  ];

  languageSteps.push("50+");

  const [languageCount, setLanguageCount] = useState(0);
  const [finished, setFinished] = useState(false);
const sectionRef = useRef(null);
const audioRef = useRef(null);
const playFeatureAudio = async () => {
  if (audioRef.current) return;

  const audio = new Audio(featureAudio);
  audioRef.current = audio;

  audio.onended = () => {
    audioRef.current = null;
  };

  try {
    await audio.play();
  } catch (err) {
    console.log("Autoplay blocked:", err);
    audioRef.current = null;
  }
};

const stopFeatureAudio = () => {
  if (!audioRef.current) return;

  audioRef.current.pause();
  audioRef.current.currentTime = 0;
  audioRef.current = null;
};
useEffect(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        playFeatureAudio();
      } else {
        stopFeatureAudio();
      }
    },
    {
      threshold: 0.6,
    }
  );

  if (sectionRef.current) {
    observer.observe(sectionRef.current);
  }

  return () => {
    observer.disconnect();
    stopFeatureAudio();
  };
}, []);
  useEffect(() => {
    let interval;

    const startCounter = () => {
      let current = 0;

      setFinished(false);
      setLanguageCount(0);

      interval = setInterval(() => {
        current += Math.floor(Math.random() * 6) + 2;

        if (current >= 50) {
          current = 50;

          setLanguageCount(50);
          setFinished(true);

          clearInterval(interval);

          // restart after 2 seconds
          setTimeout(() => {
            startCounter();
          }, 2000);

          return;
        }

        setLanguageCount(current);
      }, 80);
    };

    startCounter();

    return () => clearInterval(interval);
  }, []);

  return (
    <section 
     id="features"
    className="py-20  px-6" style={{ zoom: "0.8" }}>
      <div className="max-w-[1400px] mx-auto md:px-12 lg:px-2">
        <div className="mb-14">
          <span
            className="
							inline-block
							bg-[#E8604A29]
							text-[#E8604A]
							text-lg
							font-prompt
							font-semibold
							px-2
							py-1
							rounded-md
						"
          >
            Our core features
          </span>

          <h2
            className="
							mt-6
							font-prompt
							font-bold
							text-[#46453D]
							text-[34px]
							sm:text-[42px]
							md:text-[52px]
							lg:text-[64px]
							leading-[1.08]
							max-w-[850px]
						"
          >
            Everything You Need for Smarter Conversations
          </h2>
        </div>

        <div
          className="
			grid
			grid-cols-1

			md:grid-cols-2
			lg:grid-cols-3

			gap-6
		"
        >
          {/* CARD 1 */}

          <div
            className="
							relative
							bg-[#F7F3F2]
							border
							border-[#DDD7D4]
							rounded-[14px]
							p-8
							min-h-[420px]
							overflow-hidden
						"
          >
            <h3
              className="
								text-[#46453D]
								font-bold
								font-prompt
								text-[22px]
								relative
								z-20
							"
            >
              Industry leading latency
            </h3>

            <p
              className="
								text-[#666]
								mt-1
								relative
								font-jakarta
								z-20
							"
            >
              Experience lightning-fast response times with Craft Your Agent for
              smooth and natural conversations.
            </p>

            <div
              className="
		absolute
		left-[70px]
		bottom-[125px]

		w-[120px]
		h-[120px]

		bg-[#FFD1C8]
		rounded-full

		blur-[45px]

		opacity-90
	"
            />

            <div
              className="
		absolute
		right-[70px]
		bottom-[120px]

		w-[120px]
		h-[120px]

		bg-[#F4ED92]
		rounded-full

		blur-[45px]

		opacity-90
	"
            />
            <div
              className="
								absolute
								left-1/2
								lg:bottom-[110px]
                md:bottom-[130px]
                bottom-[80px]
								-translate-x-1/2
								z-20
							"
            >
              <img
                src={latencyCard}
                alt=""
                className="
									w-[165px]
									drop-shadow-xl

								"
              />
            </div>
          </div>

          {/* CARD 2 */}

          <div
            ref={sectionRef}
            className="
							bg-[#F7F3F2]
							border
							border-[#DDD7D4]
							rounded-[14px]
							p-8
							min-h-[420px]
						"
          >
            <h3
              className="
		text-[#46453D]
		font-prompt
		font-bold
		text-[22px]
	"
            >
              Lightning-fast speech-to-text
            </h3>

            <p
              className="
								text-[#666]
								mt-1
								font-jakarta
								mb-8
							"
            >
              Accurate real-time transcription that powers faster, smarter AI
              conversations.
            </p>

            <div className="flex items-center mb-8">
              <div
                className="
    relative

    w-[82px]
    h-[82px]

    rounded-full
    overflow-hidden

    shrink-0
    z-10
  "
              >
                <motion.img
                  src={voiceGif}
                  alt=""
                  animate={{
                    scale: [1, 1.06, 1],
                  }}
                  transition={{
                    duration: 1.2,
                    repeat: Infinity,
                  }}
                  className="
      w-full
      h-full
      object-cover
    "
                />

                {/* Play / Pause Overlay */}
                <motion.div
                  animate={{
                    scale: [1, 1.1, 1],
                  }}
                  transition={{
                    duration: 1.2,
                    repeat: Infinity,
                  }}
                  className="
      absolute
      inset-0

      flex
      items-center
      justify-center

      z-20
    "
                >
                  <img
                    src={playAI}
                    alt=""
                    className="
        w-8
        h-8
        drop-shadow-lg
      "
                  />
                </motion.div>
              </div>

              <div
                className="
    -ml-5
    bg-white
    border
    border-[#E2DEDB]
    h-[56px]
    flex
    items-center
    px-4
    flex-1
    rounded-lg
    relative
    overflow-hidden
  "
              >
                <motion.div
                  className="flex items-center w-max"
                  animate={{
                    x: ["0%", "-33.333%"],
                  }}
                  transition={{
                    duration: 17,
                    repeat: Infinity,
                    ease: "linear",
                  }}
                >
                  <img
                    src={waveform}
                    alt=""
                    className="h-[30px] w-[260px] shrink-0"
                  />
                  <img
                    src={waveform}
                    alt=""
                    className="h-[30px] w-[260px] shrink-0"
                  />
                  <img
                    src={waveform}
                    alt=""
                    className="h-[30px] w-[260px] shrink-0"
                  />
                </motion.div>
              </div>
            </div>

            <p
              className="
								text-[#46453D]
								text-[17px]
								font-jakarta
								leading-[1.8]
							"
            >
              Craft Your Agent empowers businesses to clone their own voice,
              build AI agents, and automate conversations across sales, support,
              HR, and more—all from one platform. Create personalized,
              multilingual AI experiences that sound natural and represent your
              brand with every conversation.
            </p>
          </div>

          {/* CARD 3 */}

          <div
            className="
			relative
			bg-[#F7F3F2]
			border
			border-[#DDD7D4]
			rounded-[14px]
			p-8
			min-h-[420px]
			overflow-hidden

			md:col-span-2
			md:w-[55%]
			md:mx-auto

			lg:col-span-1
			lg:w-auto
			lg:mx-0
		"
          >
            <h3
              className="
		text-[#46453D]
		font-prompt
		font-bold
		text-[22px]
	"
            >
              Multi-language translation
            </h3>

            <p
              className="
								text-[#666]
								mt-1
								font-jakarta
							"
            >
              Supports 50+ languages for seamless global conversations.
            </p>

            <div
              className="
								absolute
								left-0
								bottom-0
								w-full
								h-[68%]
							"
            >
              <img
                src={languagesBg}
                alt=""
                className="
									w-full
									h-full
									object-cover
									opacity-35
								"
              />
            </div>
            {/* Red Circle */}
            <div
              className="
		absolute
		left-[28%]
		top-[42%]

		w-[110px]
		h-[110px]

		bg-[#FFD1C8]
		rounded-full

		blur-[40px]

		opacity-90

		z-10
	"
            />

            {/* Yellow Circle */}
            <div
              className="
		absolute
		right-[24%]
		top-[42%]

		w-[110px]
		h-[110px]

		bg-[#F4ED92]
		rounded-full

		blur-[40px]

		opacity-90

		z-10
	"
            />
            <div
              className="
    absolute

    left-1/2
    top-[58%]

    -translate-x-1/2
    -translate-y-1/2

    z-30

    p-[1.5px]

    rounded-[22px]

    bg-[linear-gradient(90deg,#E8604A_0%,#E6E31F_100%)]

    shadow-[0_12px_30px_rgba(0,0,0,0.12)]
  "
            >
              <motion.div
                animate={
                  finished
                    ? {
                        scale: [1, 1.15, 1],
                      }
                    : {
                        scale: 1,
                      }
                }
                transition={{
                  duration: 0.6,
                }}
                className="
      flex
      items-center
      justify-center
	
      bg-white

      rounded-[21px]

      h-[82px]
      min-w-[210px]

      px-3
    "
              >
                <span
                  className="
    font-prompt
    font-bold

    text-[28px]

    bg-[linear-gradient(90deg,#E8604A_0%,#E6E31F_100%)]

    bg-clip-text
    text-transparent
  "
                >
                  {finished ? "50+" : languageCount}
                </span>

                <span
                  className="
    ml-2

    font-prompt
    font-bold

    text-[24px]

    bg-[linear-gradient(90deg,#E8604A_0%,#E6E31F_100%)]

    bg-clip-text
    text-transparent
  "
                >
                  language
                </span>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CoreFeatures;
